import { InputField } from '@/components/InputField';
import { isValidHttpUrl } from '@/utils';
import { Flex, Skeleton, Switch, Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import {
  PiYoutubeLogoFill,
  PiInstagramLogo,
  PiFacebookLogoFill,
  PiTwitterLogo,
  PiWhatsappLogo,
  PiLinkedinLogoFill,
  PiTiktokLogoFill,
} from 'react-icons/pi';

type SocialMediaType = 'youtube' | 'instagram' | 'facebook' | 'twitter' | 'whatsapp' | 'linkedin' | 'tiktok';

type SocialMediaEditProps = {
  socialMedia: SocialMediaType;
  value?: string;
  enabled?: boolean;
  isLoading?: boolean;
  onInputChange?: (value: string) => void;
  onEnableChange?: (value: boolean) => void;
};

const iconBySocialMedia: Record<SocialMediaType, IconType> = {
  youtube: PiYoutubeLogoFill,
  instagram: PiInstagramLogo,
  facebook: PiFacebookLogoFill,
  twitter: PiTwitterLogo,
  whatsapp: PiWhatsappLogo,
  linkedin: PiLinkedinLogoFill,
  tiktok: PiTiktokLogoFill,
};

export const SocialMediaEdit = (props: SocialMediaEditProps) => {
  const { socialMedia, value, enabled, isLoading, onInputChange, onEnableChange } = props;

  if (isLoading) {
    return (
      <Flex justifyContent='flex-start' alignItems='center' gap={3}>
        <Skeleton w='36px' h='36px' borderRadius='50%' />
        <Skeleton w='300px' h='40px' />
        <Skeleton w='26px' h='16px' borderRadius='40px' />
      </Flex>
    );
  }

  return (
    <Flex justifyContent='flex-start' alignItems='center' gap={3}>
      <Flex justifyContent='center' alignItems='center' minW='36px' minH='36px' borderRadius='50%' backgroundColor='gray.700'>
        <Icon as={iconBySocialMedia[socialMedia]} color='white' />
      </Flex>

      <InputField
        w='300px'
        value={value}
        onChange={event => onInputChange?.(event.target.value)}
        color={value && isValidHttpUrl(value) ? 'blue.600' : ''}
      />

      <Switch size='sm' isChecked={enabled} onChange={event => onEnableChange?.(event.target.checked)} />
    </Flex>
  );
};
